<div class="box card-box m-b-0">
  <div class="box-header ribbon">
    <h3>{{ 'REPORTS.columns' | translate }}
      <span *ngIf="report.columns.length > 0" class="m-l-xs">({{ report.columns.length }})</span></h3>
  </div>
  <div class="box-body clearfix">
    <gp-message *ngIf="!report?.columns?.length" text="REPORTS.no_columns_selected" type="info"></gp-message>

    <div *ngFor="let item of (report?.columns || []); let i = index">
      <gp-column-item *ngIf="item"
                      [config]="item"
                      [attr.test-id]="'gp-column-item' | gpTestId: 'report-result': item.field"
                      [enabledFields]="enabledFields"
                      (recalculateOrders)="onRecalculateOrders()"
                      (removeColumnItem)="onRemoveColumn($event)"
                      [draggable]="true"
                      (dragenter)="dragEnter(i)"
                      (dragstart)="dragStart(item)"
                      (dragend)="dragEnd()"
                      [ngStyle]="dragColumn?.field === item.field ? {border: '1px dotted #9B9B9B'} : {}"
                      style="width: 100%;">
      </gp-column-item>
    </div>
  </div>
</div>
